/**
 * @file Card/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

// These are the values that content item types can take, as received
// from the Content API.

export const ITEM_TYPE_AUDIO = "audio";
export const ITEM_TYPE_EXTERNAL_URL = "nonpolopolyURL";
export const ITEM_TYPE_PHOTOGALLERY = "photogallery";
export const ITEM_TYPE_SCORELINE = "scoreline";
export const ITEM_TYPE_STORY = "story";
export const ITEM_TYPE_STUB = "stub";
export const ITEM_TYPE_TWITTER = "twitter";
export const ITEM_TYPE_VIDEO = "video";
export const ITEM_TYPE_YOUTUBE = "youtube";
export const ITEM_TYPE_SEGMENT = "segment";
export const ITEM_TYPE_EPISODE = "episode";
export const ITEM_TYPE_BLOG = "blogentry";
export const ITEM_TYPE_FEATURE = "feature";
export const ITEM_TYPE_ALERT = "alert";
export const ITEM_TYPE_SPONSOREDCONTENT = "sponsoredcontent";
export const ITEM_TYPE_MEDIA = "media";
export const ITEM_TYPE_RECIPE = "recipe";
export const ITEM_TYPE_CONTENT_PACKAGE = "contentpackage";
export const ITEM_TYPE_PAGE = "page";

// A convenient packaging of the expected item types suitable for prop
// validation, e.g. React.PropTypes.oneOf(ITEM_TYPES).isRequired.
export const ITEM_TYPES = [
    ITEM_TYPE_AUDIO,
    ITEM_TYPE_EXTERNAL_URL,
    ITEM_TYPE_PHOTOGALLERY,
    ITEM_TYPE_SCORELINE,
    ITEM_TYPE_STORY,
    ITEM_TYPE_STUB,
    ITEM_TYPE_TWITTER,
    ITEM_TYPE_VIDEO,
    ITEM_TYPE_YOUTUBE,
    ITEM_TYPE_SEGMENT,
    ITEM_TYPE_EPISODE,
    ITEM_TYPE_BLOG,
    ITEM_TYPE_FEATURE,
    ITEM_TYPE_ALERT,
    ITEM_TYPE_SPONSOREDCONTENT,
    ITEM_TYPE_MEDIA,
    ITEM_TYPE_RECIPE,
    ITEM_TYPE_CONTENT_PACKAGE,
    ITEM_TYPE_PAGE,
];

/* When new card types added, ensure ARIA relationships exist.
   Cards contain several pieces of info, some more relevant than others to understand card function & purpose.
   Purpose is to reduce link verbosity being forced on non-visual users. Recommend keeping link text under 100 characters when possible.
   Implementing aria relationships will ensure users are not forced to listen to all content items (unless they want to) for each card.
   flag & headline considered essential for  understanding. Reference their id values (when present) using aria-labelledby={flagId headlineId} attribute.
   meta & description are complimentary info & not essential to understand function & purpose of link. reference their id values (when present) in aria-describedby={descriptionId metainfoId} attribute.
*/
export const CARD_TYPES = {
    TYPE_DEFAULT: "default",
    TYPE_TEXT: "text",
    TYPE_REGULAR: "regular",
    TYPE_LISTING: "listing",
    TYPE_LISTING_HORIZONTAL: "listing-horizontal",
    TYPE_SHOW: "show",
    TYPE_FEATURED: "featured",
    TYPE_FEATURED_AUTHOR: "featuredauthor",
    TYPE_CONTENT_PACKAGE: "contentpackage",
    TYPE_DISCOVERY: "discovery",
    TYPE_ICON_DESCRIPTION: "icon",
    TYPE_FEATURED_REVERSED: "featuredreversed",
    TYPE_LISTING_AUTHOR: "listingauthor",
};
